export const AUTH_AUDIENCES = Object.freeze({
  STAFF: "staff",
  AFFILIATE: "affiliate",
  REGULATOR: "regulator",
});

export const AUTH_AUDIENCE_VALUES = Object.freeze(
  Object.values(AUTH_AUDIENCES),
);
